import { createApp } from "vue";
import PrimeVue from "primevue/config";
import "./index.css";
import App from "./App.vue";
import router from "./router";
import "primeicons/primeicons.css";
import ToastService from "primevue/toastservice";
import "katex/dist/katex.min.css";
import pinia from "./pinia";
import i18n from "./i18n";
import Tooltip from "primevue/tooltip";
import ConfirmationService from "primevue/confirmationservice";
import { initSentry } from "./sentry";
import { useAuthStore } from "./stores/auth";
import { useOrganizationConfig } from "./stores/organizationConfig";
import { ThemePreset } from "./themes/preset";

const app = createApp(App);
initSentry(app, router);

app.use(pinia);
app.use(router);
app.use(ConfirmationService);
app.use(PrimeVue, {
  theme: {
    preset: ThemePreset,
    options: {
      darkModeSelector: ".dark-mode",
    },
  },
});
app.use(ToastService);
app.use(i18n);
app.directive("tooltip", Tooltip);
useAuthStore(); // We need to init the authStore here to perserve login
useOrganizationConfig();

app.mount("#app");
